import { render, staticRenderFns } from "./ExistingDocumentViewer.vue?vue&type=template&id=eb2e20aa&scoped=true&"
import script from "./ExistingDocumentViewer.vue?vue&type=script&lang=ts&"
export * from "./ExistingDocumentViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e20aa",
  null
  
)

export default component.exports